import React from "react";

const Loader = ({ show = true }) => {
  if (!show) return null; // Don't render if 'show' is false

  const styles = {
    preloader: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(255, 255, 255, 0.75)",
      zIndex: 10000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",

    },
    spinner: {
      width: "80px",
      height: "80px",
      border: "5px solid rgba(0, 0, 0, 0.1)",
      borderTopColor: "#de5a21",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
    },
    text: {
      marginTop: "10px",
      fontSize: "24px",
      color: "#de5a21",
    },
    loaderRow: {
      display: "flex",
      width: "100%",
      height: "100%",
    },
    loaderSection: {
      position: "absolute",
      height: "100%",
      zIndex: 1000,
      width: "25%",
    },
    leftSection: {
      left: 0,
    },
    rightSection: {
      right: 0,
    },
    
    "@keyframes spin": {
      "0%": { transform: "rotate(0deg)" },
      "100%": { transform: "rotate(360deg)" },
    },
  };

  return (
    <div id="preloader" style={styles.preloader}>
      <div className="animation-preloader">
        <div style={styles.spinner}></div>
        <p style={styles.text}>Loading</p>
      </div>
      <div className="loader">
        <div style={styles.loaderRow}>
          <div style={{ ...styles.loaderSection, ...styles.leftSection }}>
            <div style={styles.bg}></div>
          </div>
          <div style={{ ...styles.loaderSection, ...styles.leftSection }}>
            <div style={styles.bg}></div>
          </div>
          <div style={{ ...styles.loaderSection, ...styles.rightSection }}>
            <div style={styles.bg}></div>
          </div>
          <div style={{ ...styles.loaderSection, ...styles.rightSection }}>
            <div style={styles.bg}></div>
          </div>
        </div>
      </div>
      <div className="offcanvas__overlay"></div>
    </div>
  );
};

export default Loader;
